import { twMerge } from 'tailwind-merge';
import Loader from '../Button/Loader/Loader';

export interface TwButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  pending?: boolean;
  className?: string;
}

const buttonTwStyle =
  'w-full px-4 py-3 text-primary-foreground bg-primary rounded text-center uppercase sm:max-w-[420px] relative disabled:bg-muted disabled:pointer-events-none transition-colors';

export function TwButton({
  pending,
  className,
  ...buttonProps
}: TwButtonProps) {
  return (
    <button
      disabled={pending}
      className={twMerge(buttonTwStyle, className)}
      data-test="submit_btn_basics"
      {...buttonProps}
      type="button"
    >
      {pending && (
        <div className="absolute left-0">
          <Loader outline />
        </div>
      )}
      {buttonProps.children}
    </button>
  );
}

export function TwSubmitButton({
  pending,
  className,
  ...buttonProps
}: TwButtonProps) {
  return (
    <button
      disabled={pending}
      className={twMerge(
        buttonTwStyle,
        // Keep primary bg while pending so the white loader stays visible
        pending && 'disabled:bg-muted',
        className,
      )}
      data-test="submit_btn_basics"
      {...buttonProps}
      type="submit"
    >
      {pending && (
        <div className="absolute left-0">
          <Loader />
        </div>
      )}
      {buttonProps.children}
    </button>
  );
}
